var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ([304, 566].includes(_vm.user.id) || _vm.user.internal)?_c('div',[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }